import { Link } from 'react-router-dom';

export default function EventFooter() {
  return (
    <footer className="bg-stone-100 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
                alt="House of FMR"
                className="h-16 w-16 object-contain"
              />
              <div>
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 font-serif text-lg font-semibold">House of FMR</p>
                <p className="text-amber-400 text-xs tracking-wider uppercase">
                  Events & Styling
                </p>
              </div>
            </Link>
          </div>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/" className="text-stone-500 hover:text-amber-600 transition-colors cursor-pointer">Home</Link>
            <Link to="/gallery" className="text-stone-500 hover:text-amber-600 transition-colors cursor-pointer">Gallery</Link>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-amber-600 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-stone-200 text-center">
          <p className="text-stone-400 text-sm">&copy; 2025 House of FMR Events &amp; Hire. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
